import { gql } from '@apollo/client';
import { COUNTRY_FRAGMENT } from './country.gql';
import { CARRIER_FRAGMENT } from '@/graphql/fragments/kiu.gql';
import { CITY_FRAGMENT } from './city.gql';

export const BAGGAGE_FRAGMENT = gql`
    fragment BaggageType on BaggageType {
        id
        name
        qty
        weightKg
    }
`;

export const FLIGHT_CLASS_FRAGMENT = gql`
    fragment FlightClassType on FlightClassType {
        id
        name
    }
`;

export const FLIGHT_FRAGMENT = gql`
    ${CITY_FRAGMENT}
    ${CARRIER_FRAGMENT}
    fragment FlightType on FlightType {
        id
        number
        departingCity {
            ...CityType
        }
        arrivingCity {
            ...CityType
        }
        departingDatetime
        arrivingDatetime
        duration
        carrier {
            ...CarrierType
        }
    }
`;

export const ROUTE_FRAGMENT = gql`
    ${FLIGHT_CLASS_FRAGMENT}
    ${FLIGHT_FRAGMENT}
    fragment RouteType on RouteType {
        id
        flight {
            ...FlightType
        }
        status
        kiuRbd
        meals
        flightClass {
            ...FlightClassType
        }
    }
`;

export const PASSENGER_OBJECT_FRAGMENT = gql`
    ${COUNTRY_FRAGMENT}
    fragment PassengerObjectType on PassengerObjectType {
        id
        firstName
        lastName
        email
        birthDate
        nationality {
            ...CountryType
        }
        gender
        passport
        passportCreatedDate
        passportExpiredDate
        passportIssueCountry {
            ...CountryType
        }
        phone
        prefix
        documentType
    }
`;

export const ITINERARY_PASSENGER_FRAGMENT = gql`
    ${PASSENGER_OBJECT_FRAGMENT}
    fragment ItineraryPassengerType on ItineraryPassengerType {
        id
        passenger {
            ...PassengerObjectType
        }
        luggage {
            kind
            label
            asStr
            routeType
            leg
        }
        extraServices {
            name
            routeType
            leg
        }
        age
        category
    }
`;

export const ITINERARY_FRAGMENT = gql`
    ${ITINERARY_PASSENGER_FRAGMENT}
    ${ROUTE_FRAGMENT}
    fragment ItineraryType on ItineraryType {
        id
        itineraryNumber
        status
        draft
        approve
        verifiedPayment
        itineraryCreatedAt
        verificationCode
        downloadLink
        isDeleted
        isActive
        kiuBookingNumber
        canDownloadPdf
        qr
        pets {
            qty
            transportType
            transportTypeLabel
            routeType
            leg
        }
        passengers {
            ...ItineraryPassengerType
        }
        outboundFlights {
            ...RouteType
        }
        returnFlights {
            ...RouteType
        }
    }
`;
